// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_OrderController_GetList_SortOrder as SortOrderApi,
  useOrderGetListQuery,
} from 'api/generated/graphql';
import { parseOrderListItemData, useError } from 'api/helpers';
import {
  ListDataQueryFunction,
  OrdersSortField,
  OrdersListItemData,
  OrderFilterParams,
} from 'api/types/data';
import { ListData } from 'api/types/data/listData';
import { lodash } from 'helpers';
import { SortDirection } from 'libs/ui';

const sortMap: Record<NonNullable<SortDirection>, SortOrderApi> = {
  asc: SortOrderApi.Asc,
  desc: SortOrderApi.Desc,
};

export const useOrderGetList: ListDataQueryFunction<
  OrdersListItemData,
  OrderFilterParams,
  OrdersSortField
> = ({ pagination, sort, filter }) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useOrderGetListQuery({
    variables: {
      limit: pagination.limit,
      page: pagination.page + 1,
      sortBy: sort?.field,
      sortOrder: sort?.sort ? sortMap[sort.sort] : sortMap.desc,
      search: filter?.search || undefined,
    },
  });

  const error = useError(apolloError);

  const listData: ListData<OrdersListItemData> | undefined = data?.orders
    ? {
        total: data.orders.total,
        list: lodash.compact(data.orders.list).map(parseOrderListItemData),
      }
    : undefined;

  return {
    listData,
    loading,
    error,
  };
};
